import { render, staticRenderFns } from "./PartsChildrenList.vue?vue&type=template&id=b9186f56&"
import script from "./PartsChildrenList.vue?vue&type=script&lang=ts&"
export * from "./PartsChildrenList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports